import { Component, ApplicationRef, OnInit, OnDestroy } from '@angular/core';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { ViewUpdateService } from '../../scaffold/services/view-update.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { TranslationService } from '@services/translation.service';

export interface PopUpData {
  title: string;
  message: string;
  confirmMessage: string;
  declineMessage: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialog implements OnInit, OnDestroy {
  public data: any = {
    confirmMessage: this.translationService.getTranslatedContent('yes', 'Yes'),
    declineMessage: this.translationService.getTranslatedContent('no', 'No'),
  };
  private destroy$ = new Subject();
  public toMatchInput: FormControl;
  public isMatching: boolean = true;
  constructor(
    private translationService: TranslationService,
    public dialogRef: ScaffoldDialogRef,
    private viewUpdate: ViewUpdateService,
    private applicationRef: ApplicationRef
  ) {}

  get fit() {
    return this.data.hasOwnProperty('fit') ? this.data.fit : true;
  }

  get minWidth() {
    return this.data.hasOwnProperty('minWidth') ? this.data.minWidth : '400px';
  }

  ngOnInit(): void {
    if (this.data.toMatchValue) {
      this.toMatchInput = new FormControl();
      this.toMatchInput.valueChanges
        .pipe(
          takeUntil(this.destroy$),
          debounceTime(1000),
          distinctUntilChanged()
        )
        .subscribe(response => {
          this.isMatching = response === this.data.toMatchValue;
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
  }

  onYesClick(): void {
    this.dialogRef.close('confirm');
    this.viewUpdate.routeUpdated('confirm');
    setTimeout(() => {
      this.applicationRef.tick();
    }, 50);
  }

  onNoClick(): void {
    this.dialogRef.close(this.data?.declineValue);
  }

  handleClose() {
    this.dialogRef.close();
  }
}
